<script setup>
import http from "@/http";
import {ref, watchEffect} from "vue";
import DefaultImage from "@/assets/images/default-img.png"
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

const loader = ref(false);
const indicators = ref([]);
const totalElements = ref(0);
const page = ref(1);
const limit = ref(10);
const baseUrl = process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/";

const getIndicators = () => {
  loader.value = true;
  http
      .get("api/v1/indicators/organizations", {
        params: {
          offset: (page.value - 1) * limit.value,
          limit: limit.value,
        }
      })
      .then(({data}) => {
        indicators.value = data.organizations;
        totalElements.value = data.count
      })
      .finally(() => {
        loader.value = false;
      });
};
const onClickDelete = (id) => {
  ElMessageBox.confirm(
      'Ma\'lumoitni o\'chirasizmi?',
      'Diqqat!',
      {
        confirmButtonText: 'Ha',
        cancelButtonText: 'Bekor qilish',
        type: 'warning',
      }
  )
      .then(() => {
        loader.value = true
        http.delete(`/api/v1/indicators/organizations/${id}`)
            .then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              getIndicators();
            })
            .catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            })
            .finally(() => {
              loader.value = false
            })

      })
      .catch(() => {
        ElMessage({
          type: 'info',
          message: 'O\'chirish bekor qilindi',
        })
      })
}
watchEffect(() => {
  getIndicators()
})
</script>

<template>
  <el-row>
    <el-col :span="24" class="text-right">
      <!--      <el-select v-model="status" class="mr-15">-->
      <!--        <el-option value="all" label="Barchasi"/>-->
      <!--        <el-option value="true" label="Aktivlar"/>-->
      <!--        <el-option value="false" label="No aktiv"/>-->
      <!--      </el-select>-->
      <!--      <el-select v-model="lang" class="mr-15">-->
      <!--        <el-option value="uz" label="O'zbek tilida"/>-->
      <!--        <el-option value="ru" label="Rus tilida"/>-->
      <!--        <el-option value="en" label="Ingliz tilida"/>-->
      <!--      </el-select>-->
      <router-link to="indicator/add" class="el-button el-button--primary">
        Qo'shish
      </router-link>
    </el-col>
    <el-col :span="24" class="mt-15">
      <el-table :data="indicators" height="calc(100vh - 240px)" class="table" border>
        <el-table-column type="index"/>
        <el-table-column prop="logo" label="Rasim" width="110">
          <template v-slot="scope">
            <el-image
                style="width: 80px; height: 80px;"
                :src="scope.row.logo?baseUrl+scope.row.logo:DefaultImage"
                fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Nomi" min-width="220"/>
        <el-table-column prop="inn" label="STIR" min-width="100"/>
        <el-table-column prop="asbo_id" label="Asbo Id" min-width="80"/>
        <el-table-column prop="is_active" label="Holati" min-width="90">
          <template v-slot="scope">
            <el-tag :type="scope.row.is_active ? 'success':'info'" effect="dark">
              {{ scope.row.is_active ? 'Aktiv' : 'Aktiv emas' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_archive" label="Arxiv" min-width="90">
          <template v-slot="scope">
            <el-tag :type="scope.row.is_archive ? 'warning':'info'" effect="dark">
              {{ scope.row.is_archive ? 'Arxiv' : 'Arxiv emas' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="action"
            label="Amallar"
            width="200"
            align="center"
        >
          <template #default="scope">
            <el-button
                size="small"
                type="danger"
                @click="onClickDelete(scope.row?.id)"
            >
              O'chirish
            </el-button>
            <router-link
                class="el-button el-button--primary el-button--small"
                :to="`indicator/edit/${scope.row?.id}`"
            >
              Taxrirlash
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="sizes, prev, pager, next"
            :total="totalElements"
            v-model:page-size="limit"
            v-model:current-page="page"
        />
      </div>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
.mr-15 {
  margin-right: 15px;
}

.text-right {
  text-align: right;
}

.el-button--primary {
  text-decoration: none;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
